import { gql } from "@apollo/client";

export const SUBTASK_RESCHEDULING_BY_CLIENT = gql`
  mutation subtaskReschedulingByClient($input: SubtaskReschedulingByClientInput!) {
    subtaskReschedulingByClient(input: $input) {
      message
      code
      error
    }
  }
`;
export const DELETE_SUBTASK_PICKUP_FROM_CLIENT = gql`
  mutation deleteSubtaskPickupFromClient($input: DeleteInput!) {
    deleteSubtaskPickupFromClient(input: $input) {
      code
      error
      message
      data
    }
  }
`;

